/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Template_MismatchInputs */

const vi_einvoice_error_template_mismatch = /** @type {(inputs: Einvoice_Error_Template_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu hóa đơn đã chọn không còn hoạt động trên MISA. Vào Cài đặt hóa đơn, làm mới danh sách và chọn mẫu đang hoạt động.`)
};

/**

* @param {Einvoice_Error_Template_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_template_mismatch = /** @type {((inputs?: Einvoice_Error_Template_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Template_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_template_mismatch(inputs)
});